/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import Popup from '../common/Popup';
import Form from '../Auth/Form';
import { BREAKPOINT } from '../../constants/styles';

const CancelPopup = ({ children, isOpened, onClose, title }) => (
  <MediaQuery maxWidth={BREAKPOINT}>
    {isMobile => (
      <Popup
        {...{ onClose, title }}
        opened={isOpened}
        width={isMobile ? 'medium' : 'small'}
      >
        <Form>{children}</Form>
      </Popup>
    )}
  </MediaQuery>
);

CancelPopup.propTypes = {
  children: PropTypes.node,
  isOpened: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  intl: PropTypes.object,
};

export default CancelPopup;



// WEBPACK FOOTER //
// ./src/components/CircleList/CancelPopup.jsx